module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-1.8340c017.mp3";